<template>
  <div
    class="myPayments no-product-section"
    :class="{ 'no-product-section': noResultFound }" :style="`padding-top:${couponCardHeight}px`"
  >
    <div class="add-info" v-if="addedBankDetails">
      <!-- <p class="status-message" v-if="bankDetails.accountStatus === 'ACTIVE'" style="color:red;font-size:0.875em;margin-bottom:15px">
       <strong style="color:black">Note:</strong> UPI पेमेंट प्रोवाइडर के सिस्टम में टेक्निकल खराबी होने की वजह से , UPI पेमेंट ऑप्शन नहीं हो पा रहे हैं । अपना PAYTM अकाउंट सेट करें जिससे इंस्टेंट पेमेंट पा सकें ।
      </p> -->
      <p class="status-message" v-if="bankDetails.accountStatus === 'ACTIVE'">
        आपका अकाउंट ऐड हो गया है। अब आपके सारे ट्रांसक्शन इसी अकाउंट में करे
        जाएंगे।
      </p>
      <div class="edit-section">
        <div>
          <p v-if="['PAYTM','BANK_UPI','MALL91_WALLET'].includes(bankDetails.paymentTransferMode)">
            Payment Transfer Mode:
            <strong v-if="bankDetails.paymentTransferMode === 'PAYTM'"
              >PAYTM</strong
            >
            <strong v-if="bankDetails.paymentTransferMode === 'MALL91_WALLET'"
              >Mall91 Wallet</strong
            >
            <strong v-if="bankDetails.paymentTransferMode === 'BANK_UPI'"
              >Bank UPI</strong
            >
          </p>
          <p v-if="bankDetails.phone">
            Paytm Mobile Number: <strong>{{ bankDetails.phone }}</strong>
          </p>
          <p v-if="bankDetails.bankUpiId">
            Bank UPI ID : <strong>{{ bankDetails.bankUpiId }}</strong>
          </p>
          <p v-if="bankDetails.accountHolderName">
            Account Holder Name : <strong style="text-transform:capitalize">{{ bankDetails.accountHolderName }}</strong>
          </p>
          <p v-if="bankDetails.accountNumber">
            Account Number : <strong>{{ bankDetails.accountNumber }}</strong>
          </p>
          <p v-if="bankDetails.bankName">
            Bank Name : <strong>{{ bankDetails.bankName }}</strong>
          </p>
          <p v-if="bankDetails.ifscCode">
            IFSC Code : <strong>{{ bankDetails.ifscCode }}</strong>
          </p>
          <p class="bank-status" v-if="bankDetails.accountStatus === 'ACTIVE'">
            Status: <span>Activated</span
            ><span class="material-icons">check</span>
          </p>
          <p
            class="bank-status"
            v-if="bankDetails.accountStatus === 'UNDER_VERIFICATION'"
          >
            Status: <span style="color: orangered">Under Verification</span
            ><span class="material-icons">priority_high</span>
          </p>
          <p
            class="bank-status"
            v-if="bankDetails.accountStatus === 'INACTIVE'"
          >
            Status: <span style="color: red">Failed</span
            ><span class="material-icons" style="background: red">close</span
            ><br />
            <span
              class="failed-note"
              style="color: grey; font-size: 0.875em"
              v-if="bankDetails.paymentTransferMode === 'BANK_UPI'"
              >("Account verification failed. Recheck UPI ID.")</span
            >
            <span
              class="failed-note"
              style="color: grey; font-size: 0.875em"
              v-if="bankDetails.paymentTransferMode === 'PAYTM'"
              >("Account verification failed. Recheck Paytm number.")</span
            >
          </p>
        </div>

        <span class="material-icons" @click="editBankDetail()"> create </span>
      </div>
    </div>

    <div class="tracking_details">
      <p class="add-info" v-if="noBankDetails">
        अभी तक आपने कोई भी अकाउंट डिटेल नहीं दी है जिसमे माल९१ आपके सारे अमाउंट
        को भेज सके।
      </p>
      <p
        class="title"
        @click="isBankDetails = !isBankDetails"
        v-if="noBankDetails"
      >
        <span class="material-icons"> add_box </span>भुगतान के लिए डिटेल जोड़ें।
      </p>
      <div class="demo" :class="{ tracking_info: isBankDetails }">
        <div class="viewPortcnt">
          <select
            v-model="bankDetailsDTO.paymentTransferMode"
            class="selectTypepay"
            name="sortBy"
            id="sortBy"
            @change="sortBy(bankDetailsDTO.paymentTransferMode)"
          >
            <option v-for="op in paymentModeList" :value="op.value">
              {{ op.name }}
            </option>
          </select>

          <div
            class="payBackstatusbox"
            v-if="bankDetailsDTO.paymentTransferMode == 'PAYTM'"
          >
            <h3>{{ $t("paytmDetail") }}</h3>
            <input
              type="number"
              v-model="bankDetailsDTO.phone"
              class="inputtextbg"
              :placeholder="$t('enterPaytmNumber')"
            />
          </div>
          <div
            class="payBackstatusbox"
            v-if="bankDetailsDTO.paymentTransferMode == 'BANK_UPI'"
          >
            <h3>{{ $t("uPIDetail") }}</h3>
            <input
              type="text"
              v-model="bankDetailsDTO.bankUpiId"
              class="inputtextbg"
              :placeholder="$t('enterUPINumber')"
            />
          </div>

          <div
            class="payBackstatusbox add-bank-detail"
            v-if="bankDetailsDTO.paymentTransferMode == 'BANK'"
          >
            <h3>BANK</h3>
            <label>Select Bank Name</label>
             <select
            v-model="bankDetailsDTO.bankName"
            class="selectTypepay bank"
            name="sortBy"
            id="sortBy"
            @change="selectbank(bankDetailsDTO.bankName)"
          >
            <option v-for="op in banklist" :value="op">
              {{ op }}
            </option>
          </select>
          <label>Enter Account Holder Name</label>
            <input
              type="text"
              v-model="bankDetailsDTO.accountHolderName"
              class="inputtextbg"
              :placeholder="'Enter Account Holder name'"
            />
          <label>Enter Account Number</label>
            <input
              type="number"
              v-model="bankDetailsDTO.accountNumber"
              class="inputtextbg"
              :placeholder="'Account No'"
            />
            <label>Enter IFSC Code</label>
            <input
              type="text"
              v-model="bankDetailsDTO.ifscCode"
              class="inputtextbg"
              :placeholder="'IFSC Code'"
            />
          </div>
          <span class="add-dtl-btn" @click="saveDetail()">Save </span>
        </div>
      </div>
    </div>
    <!-- <p class="totalAccumulated">Rs. 2 बकाया जोड़ दिया है | टोटल बकाया - Rs 40 | Rs 50 पूरे होते ही आपके अकाउंट में आटोमेटिक ट्रांसफर हो जायेगा |</p> -->
    <div class="user-transaction-list">
      <ul class="navlisttab flx">
      <li @click="tabStatus = 'my_shop_transaction'"
        :class="tabStatus === 'my_shop_transaction' ? 'selected-tab' : ''">My Shop Transaction</li>
      <li @click="tabStatus = 'mall_supply_transaction'"
        :class="tabStatus === 'mall_supply_transaction' ? 'selected-tab' : ''">Mall91 Supply Transaction</li>
      </ul>
    </div>
    <MyShopTransaction v-if="tabStatus === 'my_shop_transaction'" />
    <MySupplyTransaction v-if="tabStatus === 'mall_supply_transaction'" />
    
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" /> 
  </div>
</template>

<script>
import "../../assets/css/order-history.scss";
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import AddBankDetails from "../OrderHistorySection/AddBankDetails";
import ProgressBarIcon from "../../components/Icons/ProgressBarIcon";
import Vue from "vue";
import MyShopTransaction from './MyShopTransaction.vue';
import MySupplyTransaction from './MySupplyTransaction.vue'
export default {
  name: "MyPayments",
  components: {
    InfiniteLoading,
    CustomToaster,
    AddBankDetails,
    ProgressBarIcon,
    MyShopTransaction,
    MySupplyTransaction
  },
  data() {
    return {
      allPayments: [],
      pageIndex: 0,
      isValidDetail: false,
      noResultFound: false,
      toasterData: {},
      limit: 20,
      paymentModeList: [
        { name: "Paytm", value: "PAYTM" },
        // { name: "Mall91 Wallet", value: "MALL91_WALLET" },
        { name: "Bank UPI", value: "BANK_UPI" },
        { name: "Bank", value: "BANK" },
      ],
      bankDetailsDTO: {
        paymentTransferMode: "PAYTM",
      },
      isBankDetails: false,
      addedBankDetails: false,
      noBankDetails: false,
      bankDetails: {},
      loading: false,
      paymentObject: {},
      resetIdentifier: +new Date(),
      timerId: null,
      showPaymentDetail: false,
      paymentTrackList: [],
      noLogFound: false,
      tabStatus: 'my_shop_transaction',
      banklist: []
    };
  },
  props: {
    couponCardHeight:{
      
    }
  },
  methods: {
    viewPaymentDetail(index, id, status) {
      if (status != null) {
        this.getPaymentStatusPerId(index, id);
      }
    },
    closeTrack() {
      this.showPaymentDetail = !this.showPaymentDetail;
      this.paymentTrackList.length = 0;
      this.noLogFound = false;
    },
    addBankdetail() {
      document.querySelector("body").classList.add("bankDetailbody");
    },
    closeCustompop() {
      document.querySelector("body").classList.remove("bankDetailbody");
    },
    selectbank(_bankName){
      this.bankDetailsDTO.bankName = _bankName
    },
    sortBy(mode) {
      this.bankDetailsDTO = {
        paymentTransferMode: mode,
      };
      if(mode === 'BANK'){
        ApiCaller('https://be.payboard.in/PayBoard/', "rest/merchant/getBankNames", "get")
        .then((data) => {
          this.loading = false;
          this.banklist = data.data
        })
        .catch((err) => {
          this.loading = false;
        });
      }
    },
    editBankDetail() {
      this.isBankDetails = !this.isBankDetails;
      // this.addedBankDetails = false
    },
    getPaymentStatusPerId(index, id) {
      this.loading = true;
      ApiCaller(constant.USER_PAYMENT_LOG, "get-user-payment-logs/" + id, "get")
        .then((data) => {
          this.loading = false;
          this.paymentTrackList = data.data;
          this.showPaymentDetail = index;
          if (this.paymentTrackList.length) {
          } else {
            this.noLogFound = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getBankDetail() {
      ApiCaller(constant.LOCAL_SHOP_URL_ORDER, "get-bank-details", "get")
        .then((data) => {
          this.loading = false;
          this.bankDetails = data.data;
          if (data.data.paymentTransferMode) {
            if (data.data.paymentTransferMode !== "") {
              this.addedBankDetails = true;
              this.isBankDetails = false;
              this.noBankDetails = false;
            }
          } else {
            this.noBankDetails = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getBankDetail();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        });
    },

    saveDetail() {
      if (this.bankDetailsDTO.paymentTransferMode === "BANK_UPI") {
        if (this.bankDetailsDTO.bankUpiId) {
          if (this.bankDetailsDTO.bankUpiId.trim().length > 4) {
            if (new RegExp(/^\w+@\w+$/g).test(this.bankDetailsDTO.bankUpiId)) {
              this.loading = true;
              ApiCaller(
                constant.LOCAL_SHOP_URL_ORDER,
                "add-bank-details",
                "post",
                this.bankDetailsDTO
              )
                .then((data) => {
                  this.loading = false;
                  this.getBankDetail();
                })
                .catch((err) => {
                  this.loading = false;
                  if (
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED" ||
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                  ) {
                    try {
                      _JWT.refereshToken = (res) => {
                        if (res != "fail") {
                          this.$cookie.set("JWT-TOKEN", res);
                          this.saveDetail();
                        } else {
                          this.loading = false;
                        }
                      };
                      JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                    } catch (err) {
                      this.loading = false;
                      console.log(err);
                    }
                  }
                  // else if(err.response.data.errorCodes[0] === "INVALID_REQUESTER_ID"){
                  //     this.toasterData = {
                  //       msg: "UPI ID is already in use",
                  //       color: "#e51c24",
                  //       iconName: "close",
                  //     };
                  //     this.isValidDetail = true;
                  // }
                  else{
                    this.toasterData = {
                      msg: err.response.data.message,
                      color: "#e51c24",
                      iconName: "close",
                    };
                    this.isValidDetail = true;
                    return false;
                  }
                });
            } else {
              this.loading = false;
              this.toasterData = {
                msg: "Enter Valid UPI ID",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          } else {
            this.loading = false;
            this.toasterData = {
              msg: "Enter Valid UPI ID",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        } else {
          this.loading = false;
          this.toasterData = {
            msg: "Enter your UPI ID",
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      } else if (this.bankDetailsDTO.paymentTransferMode === "PAYTM") {
        if (this.bankDetailsDTO.phone) {
          if (this.bankDetailsDTO.phone.trim().length > 9) {
            if (
              new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(
                this.bankDetailsDTO.phone
              )
            ) {
              this.loading = true;
              ApiCaller(
                constant.LOCAL_SHOP_URL_ORDER,
                "add-bank-details",
                "post",
                this.bankDetailsDTO
              )
                .then((data) => {
                  this.loading = false;
                  this.getBankDetail();
                })
                .catch((err) => {
                  this.loading = false;
                 
                  if (
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED" ||
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                  ) {
                    try {
                      _JWT.refereshToken = (res) => {
                        if (res != "fail") {
                          this.$cookie.set("JWT-TOKEN", res);
                          this.saveDetail();
                        } else {
                          this.loading = false;
                        }
                      };
                      JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                    } catch (err) {
                      this.loading = false;
                      console.log(err);
                    }
                  }
                  else if(err.response.data.errorCodes[0] === "INVALID_REQUESTER_ID"){
                      this.toasterData = {
                        msg: "Paytm number is already in use",
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                  }
                  else{
                    this.toasterData = {
                      msg: err.response.data.message,
                      color: "#e51c24",
                      iconName: "close",
                    };
                    this.isValidDetail = true;
                    return false;
                  }
                });
            } else {
              this.loading = false;
              this.toasterData = {
                msg: "Enter Valid Mobile Number",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          } else {
            this.loading = false;
            this.toasterData = {
              msg: "Enter Valid Mobile Number",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        } else {
          this.loading = false;
          this.toasterData = {
            msg: "Enter your Paytm Number",
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      }else if (this.bankDetailsDTO.paymentTransferMode === "BANK") {
        if (this.bankDetailsDTO.bankName && this.bankDetailsDTO.accountHolderName && this.bankDetailsDTO.accountNumber && this.bankDetailsDTO.ifscCode) {
          // if (this.bankDetailsDTO.phone.trim().length > 9) {
            if (!new RegExp(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g).test(this.bankDetailsDTO.accountHolderName )) {
              this.toasterData = {
                msg: "Enter Valid Account Holder Name",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return;
            }else if (!new RegExp(/^\d{9,18}$/g).test(this.bankDetailsDTO.accountNumber )) {
              this.toasterData = {
                msg: "Enter Valid Account Number",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return;
            }else if (!new RegExp(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/g).test(this.bankDetailsDTO.ifscCode )) {
              this.toasterData = {
                msg: "Enter Valid IFSC Code",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return;
            }
              this.loading = true;
              console.log(this.bankDetailsDTO)
              ApiCaller(
                constant.LOCAL_SHOP_URL_ORDER,
                "add-bank-details",
                "post",
                this.bankDetailsDTO
              )
                .then((data) => {
                  this.loading = false;
                  this.getBankDetail();
                })
                .catch((err) => {
                  this.loading = false;
                 
                  if (
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED" ||
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                  ) {
                    try {
                      _JWT.refereshToken = (res) => {
                        if (res != "fail") {
                          this.$cookie.set("JWT-TOKEN", res);
                          this.saveDetail();
                        } else {
                          this.loading = false;
                        }
                      };
                      JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                    } catch (err) {
                      this.loading = false;
                      console.log(err);
                    }
                  }
                  else{
                    this.toasterData = {
                      msg: err.response.data.message,
                      color: "#e51c24",
                      iconName: "close",
                    };
                    this.isValidDetail = true;
                    return false;
                  }
                });
           
        } else {
          this.loading = false;
          this.toasterData = {
            msg: "Enter Bank Detail",
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      } else {
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL_ORDER,
          "add-bank-details",
          "post",
          this.bankDetailsDTO
        )
          .then((data) => {
            this.loading = false;
            this.getBankDetail();
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.saveDetail();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
    getPaymentStatus() {
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-check-order-payment-status",
        "get"
      ).then((data) => {
        // this.pageIndex = 0;
        // this.resetIdentifier +=1;
      });
    },
    getPaymentsListing($state) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        ApiCaller(
          constant.LOCAL_SHOP_URL_ORDER,
          "get-transaction-details/" + this.pageIndex,
          "get"
        )
          .then((data) => {
            if (this.pageIndex == 0) {
              this.paymentObject = data.data;
              this.allPayments = [];
            }
            if (
              data.data.sellerPaymentDTOs &&
              data.data.sellerPaymentDTOs.length > 0
            ) {
              // this.allPayments = [];
              this.allPayments.push(...data.data.sellerPaymentDTOs);
              let inStockitem = this.allPayments.filter((it) => {
                return it.paymentRefundStatus === "PROCESSING";
              });
              this.pageIndex += 1;
              this.noResultFound = false;
              $state && $state.loaded();
              if (inStockitem.length) {
                this.getPaymentStatus();
              } else {
                clearInterval(this.timerId);
              }
            } else {
              $state && $state.complete();
            }
            if (this.allPayments.length == 0) {
              this.noResultFound = true;
            }
          })
          .catch((err) => {
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getPaymentsListing($state);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
    paymentInterval() {
      console.log('yahan')
      let count = 0;
      this.timerId = setInterval(() => {
        if (count < 10) {
          this.pageIndex = 0;
          this.allPayments = []
          this.getPaymentsListing();
          // this.resetIdentifier +=1;
        } else {
          clearInterval(this.timerId);
        }
        count++;
      }, 5000);
    },
  },
  mounted() {
    this.getBankDetail();
    // this.paymentInterval();
  },
};
</script>

<style lang="scss" scoped>
.totalAccumulated{
      color: #0063d3;
    font-size: 0.75em;
    font-weight: bold;
    margin-bottom: 8px;
}
.sidebar-menu {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  padding: 0 0 16px 0;
  transition: 0.5s;
  transform: translateX(-100%);
  padding-top: 65px;
  &.open-slide {
    transform: translateX(0);
  }
}
// .shippingDetails .order-track-status .order-state::before {
//   border-left: 2px dashed orange;
//   height: 82%;
// }
// .shippingDetails .order-track-status .order-state:after {
//   border-left: 2px dashed #c5c5c5;
//   height: 82%;
// }
// .shippingDetails .order-track-status .order-state .instatus.completed::before {
//   background: orange;
//   box-shadow: 0 0 0 1px orange;
// }
// .shippingDetails
//   .order-track-status
//   .order-state
//   .instatus.completed:last-child
//   .check {
//   transform: rotate(45deg);
//   height: 10px;
//   width: 5px;
//   border-bottom: 3px solid #fff;
//   border-right: 3px solid #fff;
//   display: block;
//   position: absolute;
//   top: 5px;
//   left: 33px;
//   z-index: 9;
// }
// .shippingDetails
//   .order-track-status
//   .order-state
//   .instatus.completed:last-child
//   .cross {
//   &:after {
//     position: absolute;
//     content: "";
//     display: block;
//     width: 4px;
//     height: 0px;
//     border: solid #e00;
//     border-width: 0 0px 12px 0;
//     transform: rotate(45deg);
//     left: 33px;
//     top: 5px;
//     z-index: 9;
//   }
//   &:before {
//     position: absolute;
//     content: "";
//     display: block;
//     width: 4px;
//     height: 0px;
//     border: solid #e00;
//     border-width: 0 0px 12px 0;
//     transform: rotate(-45deg);
//     left: 33px;
//     top: 5px;
//     z-index: 9;
//   }
// }
// .shippingDetails
//   .order-track-status
//   .order-state
//   .instatus.completed:last-child::before {
//   background: green;
//   box-shadow: 0 0 0 1px green;
// }
// .shippingDetails
//   .order-track-status
//   .order-state
//   .instatus.completed.failed:last-child::before {
//   background: white;
//   box-shadow: 0 0 0 1px red;
// }
.track-result {
  width: 100%;
  display: block;
  text-align: center;
  .success {
    font-size: 4em;
    color: green;
  }
  .failed {
    font-size: 4em;
    color: red;
  }
}
.svg_loader {
  height: 20px;
  margin: 0px auto;
  width: 200px;
  overflow: hidden;
  position: relative;
}
.svg_loader svg {
  position: absolute;
  top: -85px;
  left: -20px;
}
.myPayments {
  &.no-product-section {
    height: calc(100vh - 95px);
  }
  padding: 15px;
  .add-info {
    font-size: 0.875em;
    color: #505050;
    // position: relative;
    z-index: 9;
    .edit-section {
      background: #fff;
      box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);
      padding: 8px;
      border-radius: 10px;
      margin: 8px 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      p {
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
      .material-icons {
        color: #0063d3;
      }
      strong {
        // color: #0063D3;
      }
    }
    .bank-status {
      margin-bottom: 8px;
      span {
        color: green;
        font-weight: 600;
      }
      .material-icons {
        background: green;
        color: white;
        border-radius: 50%;
        padding: 0px;
        font-size: 1em;
        padding: 4px;
        margin-left: 8px;
      }
    }
    .status-message {
      font-weight: 600;
    }
  }
  .title {
    font-size: 0.875em;
    font-weight: 600;
    margin-top: 8px;
    color: #0063d3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
    background: #fff;
    padding: 8px;
    border-radius: 5px;
    z-index: 1;
    position: relative;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
  }
}
.heading {
  color: #484848;
  font-size: 1em;
}
.pay-amount {
  display: flex;
  justify-content: space-between;
  font-size: 0.688em;
  color: #727272;
  padding: 8px 0;
  .will-pay {
    strong {
      color: #ff0000;
    }
  }
  .paid {
    strong {
      color: #138708;
    }
  }
}
.payment-list {
  box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;
  .payment-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 15px;
    border-bottom: 1px solid #0000001f;
    padding: 8px 0;
    position: relative;

    .date-detail {
      width: 100%;
      .flx {
        justify-content: space-between;
      }
      p {
        font-size: 0.75em;
        font-weight: 600;
      }
      span {
        color: #727272;
        font-size: 0.688em;
        margin-top: 8px;
        display: block;
      }
    }
    .view-detail {
      color: #0066ff !important;
      width: 60px;
      text-align: right;
      font-size: 0.938em;
      padding-top: 8px;
      display: block;
      white-space: nowrap;
      font-weight: 600;
    }
    .retry-option {
      background: #f1f1f1;
      border: 1px solid #ddd;
      margin-top: 8px;
      padding: 8px;
      border-radius: 5px;
      p {
        font-weight: 500;
      }
      span {
        color: #0066ff !important;
        font-weight: 600;
        width: 50px;
        height: 14px;
        text-align: right;
      }
    }
    .amount-detail {
      font-size: 0.75em;
      color: #ff0000;
      font-weight: 600;
      text-align: right;
      p {
      }
    }
  }
}
.tracking_details {
  padding: 0 0 15px 0;
  .tracking_info {
    // position: absolute;
    // width: 92%;
    padding: 6px 0;
    z-index: 1;
    position: relative;
  }
}

.selectTypepay {
  width: 100%;
  margin: 0px 0 10px 0;
  display: block;
  padding: 5px;
  border-radius: 5px;
  font-size: 0.875em;
  color: #000;
  border: 1px solid rgba(0, 0, 0, 0.4);
  &.bank{
    width:96%;
  }
}
.viewPortcnt {
  // position: absolute;
  background: #fff;
  // width: 92%;
  padding: 8px;
  box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: -4px;

  // padding-top: 8px;

  .payBackstatusbox {
    width: 100%;
    display: block;
    text-align: center;

    h3 {
      width: 100%;
      text-align: left;
      font-size: 4vw;
      font-weight: 500;
      padding: 10px 0 10px 0;
      margin: 0;
      color: #000000;
    }
    .inputtextbg {
      width: 96%;
      margin: 0px 0 10px 0;
      display: block;
      padding: 5px;
      border-radius: 5px;
      font-size: 0.875em;
      color: #000;
      border: 1px solid rgba(0, 0, 0, 0.4);
      text-align: left;
    }
    &.add-bank-detail{
      text-align: left;
      label{
        text-align: left;
        font-size: 0.875em;
        margin-bottom: 4px;
        display: block;
      }
    }
  }
  .add-dtl-btn {
    background: #108805;
    color: #fff;
    padding: 8px;
    display: block;
    width: 50%;
    margin: 0 auto;
    text-align: center;
    border-radius: 25px;
  }
}
</style>